<div class="flyout-automation-history-component">
  <div class="flyout-headline-row">
    <div class="headline-title">
      <span>{{ "automations.history.title" | translate }}</span>
    </div>
    <div class="header-close-icon">
      <mat-icon class="close-icon" (click)="cancelFlyout()">close</mat-icon>
    </div>
  </div>

  <div class="tools-container">
    <div class="show-error-container">
      {{ "automations.history.showOnlyErrors" | translate }}
      <mat-slide-toggle color="primary" (change)="this.toggleShowOnlyError($event)" [disabled]="disabled"></mat-slide-toggle>
    </div>

    <div class="search-container">
      <mat-form-field hideRequiredMarker (keyup.enter)="searchIdentifier()" appearance="outline">
        <mat-label>{{ "automations.history.searchByIdentifier" | translate }}</mat-label>
        <input [(ngModel)]="identifier" matInput />
      </mat-form-field>
    </div>
  </div>

  <table mat-table [dataSource]="dataSource" multiTemplateDataRows class="mat-elevation-z8">
    <ng-container matColumnDef="status-icon">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        @if (element.allDone && !element.failed) {
          <mat-icon class="green-icon">check_circle</mat-icon>
        }
        @if (element.failed) {
          <mat-icon class="red-icon">error</mat-icon>
        }
        @if (element.warning && !element.failed) {
          <mat-icon class="orange-icon">error</mat-icon>
        }
        @if (element.unknownState) {
          <mat-icon class="orange-icon">warning</mat-icon>
        }
        @if (element.aborted) {
          <mat-icon class="blue-icon">notification_important</mat-icon>
        }
        @if (element.waiting && !element.failed && !element.warning) {
          <mat-icon class="blue-icon">watch_later</mat-icon>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="identifier">
      <th mat-header-cell *matHeaderCellDef>{{ "automations.history.identifier" | translate }}</th>
      <td mat-cell *matCellDef="let element">{{ getHeader(element) }}</td>
    </ng-container>

    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef>{{ "automations.history.date" | translate }}</th>
      <td mat-cell *matCellDef="let element">{{ element.newestExecutionTime | formatDate: "standartDateFromDate" }}</td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef class="header-align-right">{{ "automations.history.actionsDone" | translate }}</th>
      <td mat-cell *matCellDef="let element">{{ element.actionsDone }} / {{ element.totalNumberOfActions }}</td>
    </ng-container>

    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplay.length">
        <div class="example-element-detail" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
          <div class="actions-container">
            @for (event of element.events; track event; let i = $index) {
              @if (event.actionState == allActions.Done) {
                <div class="action">
                  <div class="first-row">
                    {{ i + 1 }}.
                    <img src="{{ getIconPath(event.implementationName) }}" [ngClass]="{ reverseColor: (event.implementationName | getColorAutomationIcons) }" />
                    <span class="imp-name">{{ getDisplayName(event.implementationName) }} :</span>
                    <b>
                      {{
                        event.implementationName === "RuleMailer" && event.actionName === "AddEmailToList"
                          ? ("automations.actions.AddTagsToSubscriberRule.title" | translate)
                          : (event.actionNameTranslationKey | translate)
                      }}
                    </b>
                  </div>
                  <div class="second-row">
                    {{ "automations.history.executedTime" | translate }} {{ event.executionTime | formatDate: "standartDateFromDate" }}
                    <div class="third-row">
                      {{ event.message }}
                    </div>
                  </div>
                </div>
              }
              @if (event.actionState === allActions.Error || event.actionState === allActions.Warning) {
                <div class="action">
                  <div class="first-row">
                    {{ i + 1 }}.
                    <img src="{{ getIconPath(event.implementationName) }}" [ngClass]="{ reverseColor: (event.implementationName | getColorAutomationIcons) }" />
                    <span class="imp-name">{{ getDisplayName(event.implementationName) }} :</span>
                    <b>{{ event.actionNameTranslationKey | translate }}</b>
                  </div>
                  <div class="second-row">
                    {{ "automations.history.executedTime" | translate }} {{ event.executionTime | formatDate: "standartDateFromDate" }}
                  </div>
                  <div class="third-row error" [class.warning]="event.actionState === allActions.Warning">
                    <p class="error-text" [innerHTML]="event.message"></p>
                  </div>
                  @if (isAdmin) {
                    <div>
                      <a (click)="showAndHideException(event)" class="clickable exception-button" target="_blank">
                        {{ event.showException ? ("automations.history.hideException" | translate) : ("automations.history.showException" | translate) }}
                      </a>
                      @if (event.showException) {
                        <div class="exception">
                          {{ event.stackTrace }}
                          {{ event.innerExceptionMessage }}
                          {{ event.innerExceptionStackTrace }}
                        </div>
                      }
                    </div>
                  }
                </div>
              }
              @if (event.actionState == allActions.Waiting) {
                <div class="action">
                  <div class="first-row">
                    {{ i + 1 }}.
                    <img src="{{ getIconPath(event.implementationName) }}" [ngClass]="{ reverseColor: (event.implementationName | getColorAutomationIcons) }" />
                    <span class="imp-name">{{ getDisplayName(event.implementationName) }} :</span>
                    {{ event.actionNameTranslationKey | translate }}
                  </div>
                  <div class="second-row">
                    {{ "automations.history.executedTime" | translate }} {{ event.executionTime | formatDate: "standartDateFromDate" }}
                  </div>
                  <div class="third-row">
                    {{ event.message }}
                  </div>
                </div>
              }
              @if (event.actionState == allActions.Aborted) {
                <div class="action">
                  <div class="first-row">
                    {{ i + 1 }}.
                    <img src="{{ getIconPath(event.implementationName) }}" [ngClass]="{ reverseColor: (event.implementationName | getColorAutomationIcons) }" />
                    <span class="imp-name">{{ getDisplayName(event.implementationName) }} :</span>
                    {{ event.actionNameTranslationKey | translate }}
                  </div>
                  <div class="second-row">
                    {{ "automations.history.executedTime" | translate }} {{ event.executionTime | formatDate: "standartDateFromDate" }}
                  </div>
                  <div class="third-row">{{ "automations.history.aborted" | translate }} {{ event.message }}</div>
                </div>
              }
            }
            <div>
              <a [href]="gotoSessionDetails(element)" class="clickable session-link" target="_blank">
                {{ "automations.history.goto-visit" | translate }}
              </a>
            </div>
          </div>
        </div>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr
      mat-row
      *matRowDef="let element; columns: columnsToDisplay"
      class="example-element-row"
      [class.example-expanded-row]="expandedElement === element"
      (click)="expandedElement = expandedElement === element ? null : element"></tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
  </table>

  @if (!canShowMore && dataSource.length == 0 && !isLoading) {
    <div class="no-data">
      {{ "automations.history.noData" | translate }}
    </div>
  }

  @if (isLoading) {
    <div class="loading">
      <mat-progress-spinner [diameter]="64" [strokeWidth]="2" mode="indeterminate"></mat-progress-spinner>
    </div>
  }

  @if (canShowMore) {
    <div fxLayoutAlign="center">
      <button class="stroked-btn" mat-flat-button (click)="skipOneAndShowMore()">
        <span class="btn-label">
          {{ "automations.history.more" | translate }}
          <mat-icon>keyboard_arrow_right</mat-icon>
        </span>
      </button>
    </div>
  }
</div>
